import { useState, useEffect,useRef  } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import {
  Modal,
  Backdrop,
  Fade,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import AssessmentIcon from '@material-ui/icons/Assessment';

export default function HlsAnalytics({
  classes,
  room,
  stats,
  videoKbps,
  audioKbps,
}) {
  const [open, setOpen] = useState(false);
  const [displayVideoKbps, setDisplayVideoKbps] = useState(0);
  const [displayAudioKbps, setDisplayAudioKbps] = useState(0);
  const lastValidVideo = useRef(0);
  const lastValidAudio = useRef(0);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (videoKbps !== undefined && videoKbps !== null && videoKbps > 0) {
      lastValidVideo.current = videoKbps;
      setDisplayVideoKbps(videoKbps);
    }
  }, [videoKbps]);

  useEffect(() => {
    if (audioKbps !== undefined && audioKbps !== null && audioKbps > 0) {
      lastValidAudio.current = audioKbps;
      setDisplayAudioKbps(audioKbps);
    }
  }, [audioKbps]);

  useEffect(() => {
    if (!stats) {
      setDisplayVideoKbps(0);
      setDisplayAudioKbps(0);
      lastValidVideo.current = 0;
      lastValidAudio.current = 0;
    }
  }, [stats]);

  const formatKbps = (value) => {
    if (value === undefined || value === null) return '—';
    return typeof value === 'number' ? value.toFixed(2) : value;
  };

  return (
    <div>
      <Tooltip title='Analytics'>
        <IconButton
          aria-label='more'
          aria-controls='long-menu'
          aria-haspopup='true'
          className={classes.toolbarButtons}
          onClick={handleOpen}
        >
          <AssessmentIcon />
        </IconButton>
      </Tooltip>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 600,
              backgroundColor: 'white',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
            }}
          >
            {/* <IconButton aria-label='close' onClick={handleClose}>
              <CloseIcon />
            </IconButton> */}
            <span className='close-modal' onClick={handleClose}>
              &times;
            </span>
            <h2
              id='transition-modal-title'
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              Stream quality
            </h2>
            <h6 style={{ display: 'flex', justifyContent: 'center' }}>
              Meeting Id: {sessionStorage.getItem('sessionId')}
            </h6>
            <TableContainer component={Paper}>
              <Table aria-label='analytics table'>
                <TableHead>
                  <TableRow>
                    <TableCell>Type</TableCell>
                    <TableCell>Total Bytes Sent</TableCell>
                    <TableCell>Kbps</TableCell>
                    <TableCell>Packets Sent</TableCell>
                    <TableCell>Packets Lost</TableCell>
                  </TableRow>
                </TableHead>
                {stats && Object?.keys(stats.audio)?.length ? (
                  <TableBody>
                    <TableRow>
                      <TableCell>Audio</TableCell>
                      <TableCell>{stats.audio.bytesSent}</TableCell>
                      <TableCell>{formatKbps(displayAudioKbps)}</TableCell>
                      <TableCell>{stats.audio.packetsSent}</TableCell>
                      <TableCell>{stats.audio.packetsLost}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Video</TableCell>
                      <TableCell>{stats.video.bytesSent}</TableCell>
                      <TableCell>{formatKbps(displayVideoKbps)}</TableCell>
                      <TableCell>{stats.video.packetsSent}</TableCell>
                      <TableCell>{stats.video.packetsLost}</TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={5} align='center'>
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                )}
              </Table>
            </TableContainer>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
